import React, { useEffect } from "react";
import AuthService from "../services/AuthService";

export default function Logout() {
  useEffect(() => {
    AuthService.logout().catch((error) => {
      console.error("Unable to sign out cleanly.", error);
      AuthService.logoutLocal();
      window.location.hash = "#/login";
    });
  }, []);

  return <h1>Log out</h1>;
}
